import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { images } from "../assets/images";
import { BackgroundMedia } from "./BackgroundMedia";

export function CoffeeSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section
      ref={ref}
      className="relative h-screen w-full flex items-center justify-center overflow-hidden"
    >
      {/* 左侧图片 - 咖啡与城市 */}
      <motion.div
        initial={{ x: "-100%", opacity: 0 }}
        animate={isInView ? { x: 0, opacity: 1 } : { x: "-100%", opacity: 0 }}
        transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
        className="absolute left-0 top-0 w-1/2 h-full"
      >
        <BackgroundMedia
          videoSrc={images.coffee}
          imageSrc={images.coffeeImage}
          className="w-full h-full object-cover"
        />
        {/* 渐变遮罩 - 向右渐变到透明 */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-black/30" />
      </motion.div>

      {/* 右侧图片 - 孩子的微笑 */}
      <motion.div
        initial={{ x: "100%", opacity: 0 }}
        animate={isInView ? { x: 0, opacity: 1 } : { x: "100%", opacity: 0 }}
        transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
        className="absolute right-0 top-0 w-1/2 h-full"
      >
        <BackgroundMedia
          videoSrc={images.childSmile}
          imageSrc={images.childSmileImage}
          className="w-full h-full object-cover"
        />
        {/* 渐变遮罩 - 向左渐变到透明 */}
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-transparent to-black/30" />
      </motion.div>

      {/* 中央分隔线 */}
      <motion.div
        initial={{ scaleY: 0, opacity: 0 }}
        animate={isInView ? { scaleY: 1, opacity: 1 } : { scaleY: 0, opacity: 0 }}
        transition={{ duration: 1, delay: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-white/50 to-transparent origin-top"
      />

      {/* 中央文字内容 */}
      <div className="relative z-10 flex items-center justify-center w-full h-full px-6">
        <motion.div
          initial={{ opacity: 0, scale: 0.9, y: 30 }}
          animate={isInView ? { opacity: 1, scale: 1, y: 0 } : { opacity: 0, scale: 0.9, y: 30 }}
          transition={{ duration: 1, delay: 1.2, ease: [0.22, 1, 0.36, 1] }}
          className="text-center max-w-xl"
        >
          {/* 主标题 */}
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 1, delay: 1.5 }}
            className="text-white text-xl md:text-3xl lg:text-4xl leading-tight mb-4 drop-shadow-2xl"
          >
            是时候
            <br />
            为这个世界的暗处
            <br />
            点一盏灯了
          </motion.h2>

          {/* 装饰线 */}
          <motion.div
            initial={{ scaleX: 0 }}
            animate={isInView ? { scaleX: 1 } : { scaleX: 0 }}
            transition={{ duration: 1, delay: 1.8 }}
            className="h-0.5 w-24 bg-gradient-to-r from-amber-400 via-white to-blue-400 mx-auto origin-center"
          />

          {/* 底部提示文字 */}
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 10 }}
            transition={{ duration: 0.8, delay: 2.3 }}
            className="text-white/90 text-base md:text-lg mt-6 px-4 drop-shadow-lg"
          >
            您的温暖，能照亮他们的未来
          </motion.p>
        </motion.div>
      </div>

      {/* 顶部和底部渐变遮罩 */}
      <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-black/40 to-transparent pointer-events-none" />
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black/40 to-transparent pointer-events-none" />
    </section>
  );
}

